import Content from "../common/Content";
import Footer from "../common/Footer";
import Header from "../common/Header";
import DataTable from "react-data-table-component";
import { API } from "../../helper/Api";
import { useState, useEffect,useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RotatingLines } from "react-loader-spinner";
import $ from "jquery";
import SessionHandler from "../common/SessionHandler";
import { useRole } from "../contextApi/RoleContext";
import { useLocation,Link, useNavigate } from "react-router-dom";


export default function TicketsHistory() {
    const { setRole, role, setPermission, permission, setUserDetails,userDetails} =useRole();
    const contentRef = useRef(null);
  const [items, setItems] = useState([]);
  const [itemDetails, setItemDetails] = useState([]);
  const [pending, setPending] = useState(true);
  const [storeCode, setStoreCode] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectStore, setSelectStore] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [filterCol, setFilterCol] = useState('ticketno');
  const [filterType, setFilterType] = useState('equal');
  const [inputVal, setInputVal] = useState('');
  const [dynamicFields, setDynamicFields] = useState([{ filterName: "", filterType: "", filterValue: "",filterTypeOpt:[],filterNameOpt:[{value:"ticketno",name:"#Ticket No"},{value:"subtotal",name:"Sub-Total(w/o tax)"},{value:"discount",name:"Discount"},{value:"tax",name:"Tax"},{value:"sales",name:"Total Sales"}] }]);


  const location = useLocation();
  const API_URL = process.env.REACT_APP_BASE_URL;

  const table = $('#myTableTicket').DataTable();


const toggleCollapse = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    if (contentRef.current) {
      // Reset max-height to auto when content is fully expanded
      if (isOpen) {
        contentRef.current.style.maxHeight = `${contentRef.current.scrollHeight}px`;
      } else {
        contentRef.current.style.maxHeight = '0';
      }
    }
  }, [isOpen]);



/* Date converted to MM-DD-YYYY format */

  useEffect(() => {
    getTicketsLists();
    if(userDetails.storecode?.length > 1 || userDetails?.usertype === "CORP"){
      fetchStoreCode();
    }
    
  }, []);

 /////convert the time into US format 

const dateConvert = (dateString)=>{
  const date = new Date(dateString);

   // Format the date as MM/DD/YYYY
   const month = (date.getMonth() + 1).toString().padStart(2, '0'); // getMonth() is zero-indexed
   const day = date.getDate().toString().padStart(2, '0');
   const year = date.getFullYear();
 
   // Format the time as hh:mm AM/PM
   let hours = date.getHours();
   const minutes = date.getMinutes().toString().padStart(2, '0');
   const isAM = hours < 12;
   
   // Convert to 12-hour format
   hours = hours % 12 || 12; // The hour 0 should be 12 in 12-hour format
   const period = isAM ? 'AM' : 'PM';
 
   return `${month}/${day}/${year}`;

}

 const formatDate = (dateString) => {
  const date = new Date(dateString);
  
  // Format the date as MM/DD/YYYY
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // getMonth() is zero-indexed
  const day = date.getDate().toString().padStart(2, '0');
  const year = date.getFullYear();

  // Format the time as hh:mm AM/PM
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const isAM = hours < 12;
  
  // Convert to 12-hour format
  hours = hours % 12 || 12; // The hour 0 should be 12 in 12-hour format
  const period = isAM ? 'AM' : 'PM';

  return `${month}/${day}/${year} ${hours}:${minutes} ${period}`;
};

  ///get the store code /////
  const fetchStoreCode = async () => {
    try {
      let extractCode;
      const result = await API.getLocationStoreCode();
      if(userDetails?.usertype === "CORP"){
        extractCode = result.ApiDocument.Response.Locations.map(
          (item) => {
            return { code: item.Code,name: item.Name };
          }
        );
      }else{
        extractCode = result.ApiDocument.Response.Locations.filter(it => userDetails.storecode.some(its=> its.storecode === it.Code)).map(
          (item) => {
            return { code: item.Code,name: item.Name };
          }
        );
      }
     
      setStoreCode(extractCode);
      console.log("location",extractCode)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
//////end////////////////////////


  const getTicketsLists = async(type) => {

    if(type ==="filter"){
      //setPending(true);
      // console.log("store code len",userDetails.storecode.length)
       
          try{
           await  API.getSalesRecipt({page:0,from:fromDate,to:toDate})
           .then((datas) => {
              let filteredSales;
                  let items;
                //  setPending(false);
                  if(userDetails.usertype !=="CORP"){
                    filteredSales = datas.ApiDocument.Response.SalesReceipts.filter(rec => userDetails.storecode?.some(itm=> itm.storecode === rec.Location));
                    items = filteredSales.flatMap(
                     (SalesReport) => SalesReport
                   );
                  //  setSalesCount(items.length);
                  }else{
                   
                    items = datas.ApiDocument.Response.SalesReceipts.flatMap(
                     (SalesReport) => SalesReport
                   );
                  //  setSalesCount(data.ApiDocument.TotalRecords);
                  }
                  // let finalFilter;
                  // if(selectStore){
                  //   finalFilter = items.filter((item)=>{
                  //     return item.Location === selectStore;
                  //   });
                  // }
                  // if(dynamicFields.length > 1 || dynamicFields[0].filterName !=""){
                  //    finalFilter=items.filter((item)=>{
                  //     return dynamicFields.some(get => get.filterValue == item.DeviceTransactionNumber);
                  //    });
                  // }
                  
                  //filter functionality start here
// Comparison functions for different operators
function applyComparison(itemValue, filterValue, operator) {
  switch (operator) {
    case '1':
      return itemValue > filterValue;
    case '3':
      return itemValue < filterValue;
    case '2':
      return itemValue >= filterValue;
    case '4':
      return itemValue <= filterValue;
    case '0':
      return itemValue == filterValue;
  
  }
}

// Function to apply multiple filters dynamically
function applyFilters(data, filters) {
  return data.filter(item => {
    return Object.keys(filters).every(key => {
      const filter = filters[key];
      // console.log(item[key])
      //   console.log(typeof(filter.filterValue));
      //   console.log(filter.filterType)
      if (filter && filter.filterValue && filter.filterType) {
        console.log("test")
        // Apply the comparison based on operator
        return applyComparison(item[key], Number(filter.filterValue), filter.filterType);
      }
      return true;  // If no filter is applied for this key
    });
  });
}
const subTotalLen = dynamicFields.find(i=> i.filterName =="subtotal");
                  const discountLen = dynamicFields.find(i=> i.filterName =="discount");
                  const taxLen = dynamicFields.find(i=> i.filterName =="tax");
                  const totalSalesLen = dynamicFields.find(i=> i.filterName =="sales");

const filters = {};
if(selectStore){
  filters.Location ={filterValue:selectStore,filterType:"0"};
}
if (subTotalLen) {
  filters.TotalAmountWithoutTax = subTotalLen;
}

if (discountLen) {
  filters.TotalDiscountAmount = discountLen;
}

if (taxLen) {
  filters.TotalTaxAmount = taxLen;
}

if (totalSalesLen) {
  filters.TotalAmount = totalSalesLen;
}
console.log(filters)
// Apply filters to data
const filteredData = applyFilters(items, filters);

console.log("filter res",filteredData);





                  /////////filter functionality end here /////
                //   let finalFilter;
                //   let finalSubTot;
                //   let finalDiscount;
                //   let finalTax;
                //   let finalTotalSales;
                //   const subTotalLen = dynamicFields.find(i=> i.filterName =="subtotal");
                //   const discountLen = dynamicFields.find(i=> i.filterName =="discount");
                //   const taxLen = dynamicFields.find(i=> i.filterName =="tax");
                //   const totalSalesLen = dynamicFields.find(i=> i.filterName =="sales");
                //   finalFilter = items.filter((item) => {
                //     const isLocationMatch = selectStore ? item.Location === selectStore : true;
                //     const isDeviceTransactionNumberMatch = dynamicFields.length > 1 || dynamicFields[0].filterName !== ""
                //       ? dynamicFields.some(get => get.filterValue == item.DeviceTransactionNumber)
                //       : true;
                //     return isLocationMatch || isDeviceTransactionNumberMatch;
                //   });
                //  // console.log("store",finalFilter);
              
                //   //console.log("find subtotal value",subTotalLen);
                //   if(finalFilter.length > 0 && subTotalLen) {
                //     let comparisonFunction;
                  
                //     // Define the comparison function based on filterType
                //     switch(subTotalLen.filterType) {
                //       case "0":
                //         comparisonFunction = (is) => is.TotalAmountWithoutTax == subTotalLen.filterValue;
                //         break;
                //       case "1":
                //         comparisonFunction = (is) => is.TotalAmountWithoutTax > subTotalLen.filterValue;
                //         break;
                //       case "2":
                //         comparisonFunction = (is) => is.TotalAmountWithoutTax >= subTotalLen.filterValue;
                //         break;
                //       case "3":
                //         comparisonFunction = (is) => is.TotalAmountWithoutTax < subTotalLen.filterValue;
                //         break;
                //       case "4":
                //         comparisonFunction = (is) => is.TotalAmountWithoutTax <= subTotalLen.filterValue;
                //         break;
                //       default:
                //         comparisonFunction = () => true; // No filter applied if type is invalid or missing
                //     }
                  
                //     // Apply the filter once using the selected comparison function
                //     finalSubTot = finalFilter.filter(comparisonFunction);
                //   }
                 
                //  // console.log("filtered apis", finalSubTot);
                //   console.log("selected store",selectStore);
           })
          }catch(err){
           console.error("Error fetching Employee data:", err);
          }
    }else{
      setPending(true);
// console.log("store code len",userDetails.storecode.length)
 
    try{
     await  API.getSalesRecipt({page:0})
     .then((datas) => {
        let filteredSales;
            let items;
            setPending(false);
            if(userDetails.usertype !=="CORP"){
              filteredSales = datas.ApiDocument.Response.SalesReceipts.filter(rec => userDetails.storecode?.some(itm=> itm.storecode === rec.Location));
              items = filteredSales.flatMap(
               (SalesReport) => SalesReport
             );
            //  setSalesCount(items.length);
            }else{
             
              items = datas.ApiDocument.Response.SalesReceipts.flatMap(
               (SalesReport) => SalesReport
             );
            //  setSalesCount(data.ApiDocument.TotalRecords);
            }
            
            console.log("first apis", items);
           // $("#myTable1").DataTable().destroy();
            setItemDetails(items);
          
      
     })
    }catch(err){
     console.error("Error fetching Employee data:", err);
    }
    }
    

 ////////end////////////////
  };


  

  useEffect(() => {
    

    if(itemDetails.length > 0){
      console.log("yes")
      $("#myTableTicket").DataTable({
        paging: true,
        searching: true,
        ordering: true,
        info: true,
        lengthChange: true,
        pageLength: 25,
        responsive: true,
        colReorder: true,
        autoWidth: false,
        destroy: true,
        stateSave: true,
        layout: {
          topStart: {
            buttons: [
              "copy",
              "csv",
              "excel",
              "pdf",
              "print",
              {
                extend: "colvis",
                collectionLayout: "fixed columns",
                popoverTitle: "",
              },
            ],
          },
        },
      });

    }

  }, [itemDetails]);

  
  const handleFilterClick = async() => {
   // $("#myTable1").DataTable().destroy();
    getTicketsLists("filter");
   // setItemDetails()

   return false;
   
    const from1 = new Date(fromDate);
    const to1 = new Date(toDate);

    var track = true;
      // if (!fromDate || !toDate) {
      //   validation("Both From Date and To Date are required.");
      //   track = true;
      // }
    if (from1 > to1) {
     validation("From Date shouldn't be after To Date.");
      track = true;
    }
    if(!track){

    
    const table = $('#myTableTicket').DataTable();
  
    // Clear previous custom filters
    $.fn.dataTable.ext.search.length = 0;
  
    // Custom filtering logic
    const from = fromDate ? new Date(fromDate) : null;
    const to = toDate ? new Date(toDate) : null;
  
    // Normalize the time to midnight for both fromDate and toDate, if they are provided
    if (from) from.setHours(0, 0, 0, 0);  // Set to midnight
    if (to) to.setHours(23, 59, 59, 999); // Set to end of the day (23:59:59)
  
    $.fn.dataTable.ext.search.push((settings, data, dataIndex) => {
      const name = data[0].toLowerCase(); // Assuming name is in the first column (index 0)
      const dateStr = data[2]; // Assuming "rec_modified" is the 5th column (index 4)
      const date = new Date(dateStr);
  
      // Ensure the date is valid before proceeding
      if (isNaN(date)) return false; // Skip rows with invalid date
  
      // Check if the row matches the custom search term
      const matchesSearchTerm = selectStore === '' || name.includes(selectStore.toLowerCase());
  
      // Check if the row's date is within the "From" and "To" range
      const matchesDateRange = 
        (!from || date >= from) && 
        (!to || date <= to);
  
      // Only show the row if it matches both conditions
      return matchesSearchTerm && matchesDateRange;
    });
  
    // Redraw the table with the new filters
    table.draw();
  }
  };
  


  //handle filter clear/////
 const handleFilterClear=()=>{
// Clear previous custom filters
setFromDate('');
setToDate('');
setSelectStore('')
if(dynamicFields.length > 0){
const list=[...dynamicFields];
list.forEach((item)=>{
  return item.filterValue="";
})
setDynamicFields(list);
console.log(list);
}else{
setDynamicFields([{ filterName: "", filterType: "", filterValue: "",filterTypeOpt:[],filterNameOpt:[{value:"ticketno",name:"#Ticket No"},{value:"subtotal",name:"Sub-Total(w/o tax)"},{value:"discount",name:"Discount"},{value:"tax",name:"Tax"},{value:"sales",name:"Total Sales"}] }]);
 }

}

  //////end/////////////////

  //dynamic filter column///

const handleFilterCol=(e)=>{
  console.log(e.target.value);
}

  /////end/////////////
  //filter type column///

const handleFilterType=(e)=>{
  console.log(e.target.value);
}

  /////end/////////////

  ///create dynamic filter field///
const handleCreate=()=>{
  if(dynamicFields.length <=4){
    contentRef.current.style.maxHeight = `${contentRef.current.scrollHeight+75}px`;
    setDynamicFields([...dynamicFields,{ filterName: "", filterType: "", filterValue: "",filterTypeOpt:[],filterNameOpt:[{value:"ticketno",name:"#Ticket No"},{value:"subtotal",name:"Sub-Total(w/o tax)"},{value:"discount",name:"Discount"},{value:"tax",name:"Tax"},{value:"sales",name:"Total Sales"}] }]);
  }
  
}
  ///////end//////////////////////
  ////remove the filter fields///
const handleRemove=(e)=>{
  if(e !=0){
    const list=[...dynamicFields];
    list.splice(e,1);
    setDynamicFields(list);
  }
 // console.log(e)
}


  //////end////////////////////

  ////handle dynamic field values///
const handleDynamicVal=(e,indx)=>{
  const {name,value}=e.target;
  const list =[...dynamicFields];
  list[indx][name]=value;
  
  // switch(value){
  //   case "ticketno": list[indx].filterTypeOpt = [{value:"0",name:"="}]; break;
  //   default: list[indx].filterTypeOpt = [{value:"0",name:"="},{value:"1",name:">="},{value:"2",name:"<"},{value:"3",name:"<="}]; break; 
  // }


  switch(value){

    case "ticketno": 
    // list[indx].filterNameOpt = [{value:"ticketno",name:"#Ticket No"}]; 
    list[indx].filterTypeOpt = [{value:"0",name:"="}]; 
    break;
    case "subtotal": 
    // list[indx].filterNameOpt = [{value:"subtotal",name:"Sub-Total(w/o tax)"}];
     list[indx].filterTypeOpt = [{value:"0",name:"="},{value:"1",name:">"},{value:"2",name:">="},{value:"3",name:"<"},{value:"4",name:"<="}];
      break;
    case "discount": 
    // list[indx].filterNameOpt = [{value:"discount",name:"Discount"}]; 
    list[indx].filterTypeOpt = [{value:"0",name:"="},{value:"1",name:">"},{value:"2",name:">="},{value:"3",name:"<"},{value:"4",name:"<="}];
     break;
    case "tax": 
    // list[indx].filterNameOpt = [{value:"tax",name:"Tax"}];
    list[indx].filterTypeOpt = [{value:"0",name:"="},{value:"1",name:">"},{value:"2",name:">="},{value:"3",name:"<"},{value:"4",name:"<="}]; 
    break;
    case "sales":
      // list[indx].filterNameOpt = [{value:"sales",name:"Total Sales"}];
    list[indx].filterTypeOpt = [{value:"0",name:"="},{value:"1",name:">"},{value:"2",name:">="},{value:"3",name:"<"},{value:"4",name:"<="}]; 
    break;
   
  }

  setDynamicFields(list);
  console.log("filter",dynamicFields);
}
{console.log(dynamicFields)}
  //////end////////////////////////

  ///apply validation for filter////
  const validation = (message) => {
    toast.error(message, {
      position: "top-center",
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "colored",
      className: "login-toast",
    });
  };



  /////////////////////////////
  
  const selectStyles = {
    width: "100%",
    padding: "8px",
    fontSize: "14px",
    borderRadius: "4px",
    border: "1px solid #ced4da",
    backgroundColor: "#fff",
    marginTop:"-3px",
    outline: "none",
    cursor: "pointer",
    height: "47px",
    color: "black",
  };


  return (
    <>
    <div className="container-fluid page-body-wrapper">
      <div className="main-panel">
        <div className="content-wrapper">
        <ToastContainer
                position="top-center"
                autoClose={500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
              />
            <div class="Card_contend">

              {pending ? (
                <div className="loader">
                  <RotatingLines
                    visible={true}
                    height="96"
                    width="96"
                    strokeColor="grey"
                    strokeWidth="2"
                    animationDuration="0.75"
                    ariaLabel="rotating-lines-loading"
                  />
                </div>
              ) : (
                <div >


                <div class="date_range">
                <h2>Tickets History</h2>
                </div>
               {/* Button to toggle the collapse */}
      <button
        className={`btn btn-${isOpen ? 'secondary' : 'primary'}`}
        onClick={toggleCollapse}
      >
        {isOpen ? 'CLOSE' : 'FILTER'}
      </button>

      {/* Collapsible content with smooth transition */}
      <div
        ref={contentRef}
        style={{
          maxHeight: isOpen ? '0' : '0', // start collapsed
          overflow: 'hidden',
          transition: 'max-height 0.5s ease-in-out', // Apply smooth transition on max-height
        }}
      >
        <div className="card card-body mt-3 filterCard">
            <div className="row"> 
            <div className="col-md-3">
                    <label htmlFor="fromDate" className="form-label">
                      From Date
                    </label>
                    <input
                      type="date"
                      id="fromDate"
                      className="form-control"
                      // style={{ width: "50%" }}
                      value={fromDate}
                       onChange={(e)=>setFromDate(e.target.value)}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="toDate" className="form-label">
                      To Date
                    </label>
                    <input
                      type="date"
                      id="toDate"
                      // style={{ width: "50%" }}
                      className="form-control"
                      value={toDate}
                       onChange={(e)=>setToDate(e.target.value)}
                    />
                  </div>
                  {userDetails.storecode?.length > 1 || userDetails?.usertype === "CORP" ? (
                    <div className="col-md-3">
                  <label  className="form-label">
                       Store
                     </label>
                     <select  style={selectStyles} onChange={(e)=>setSelectStore(e.target.value)} value={selectStore} >
                         <option value=''>All</option>
                         {storeCode.filter(it=> it.code !== "HQ" && it.code !== "INTRANSIT" && it.code !== "TEST").map((item,index)=>{
                             return <option key={index} value={item.code}>{item.name}</option>
                         })}
                     </select>
                  </div>
                  ):('')}
                  
                  <div className="col-md-3">
                    
                    <button
                      className="btn btn-primary"
                     style={{marginTop:"29px"}}
                      onClick={handleFilterClick}
                    >
                      APPLY
                    </button>
                   
                    <button
                      className="btn btn-secondary"
                     style={{marginTop:"29px",marginLeft:"10px"}}
                      onClick={handleFilterClear}
                    >
                      CLEAR
                    </button>
                  </div>

            </div>
            {dynamicFields.map((item,index)=>{
              {console.log(item.filterValue)}
              return(
              <div className="row mt-3"> 
            <div className="col-md-3">

            <label  className="form-label">
                       Select Filter
                     </label>
                     <select  style={selectStyles} onChange={e=>handleDynamicVal(e,index)} name="filterName"  value={item.filterName}>

                         <option value=''>select</option>
                         {item.filterNameOpt.map((i)=>{
                          return  <option value={i.value}>{i.name}</option>
                         })}
                       
                     </select>
            </div>
            <div className="col-md-3">
            <label  className="form-label">
            Select Type
                     </label>
                     <select  style={selectStyles} onChange={e=>handleDynamicVal(e,index)} name="filterType"  value={item.filterType}>
                     <option value=''>select</option>
                        {item.filterTypeOpt.map((i)=>{
                          return <option value={i.value}>{i.name}</option>
                        })}
                        
                     </select>
            </div>
            <div className="col-md-3">
            <label  className="form-label">
            Value
                     </label>
                     <input type="number" style={selectStyles} className="form-control" name="filterValue" onChange={e=>handleDynamicVal(e,index)}  value={item.filterValue}/>
            </div>
            <div className="col-md-3">
              <div style={{marginTop:"30px"}}>{console.log("find len->",dynamicFields.length)}
              {dynamicFields.length-1 ===index && <i class="mdi mdi-plus-circle"  style={{fontSize:"26px",color:"#0062ff",cursor:"pointer"}} onClick={handleCreate}/>}
             {dynamicFields.length >1 && <i class="mdi mdi-close-circle"  style={{fontSize:"26px",color:"",cursor:"pointer"}} onClick={()=>handleRemove(index)}/>} 
              </div>


            </div>
            </div>)
            })}
            
                </div>
      </div>
      


                  {!pending ? (
                    <table id="myTableTicket" className="row-border">
                      <thead>
                        <tr>
                        <th style={{ display: userDetails.storecode?.length > 1 || userDetails?.usertype === "CORP" ? 'table-cell' : 'none' }}>Store</th>
                          <th>#Ticket No</th>
                          <th>Ticket Date</th>
                          <th>Sub-Total(w/o tax)</th>
                          <th>Discount</th>
                          <th>Tax</th>
                          <th>Total Sales</th>
                        </tr>
                      </thead>
                      <tbody>
                        {console.log("test",itemDetails.length)}
                       {itemDetails?.map((itemDetail,index) =>(
                          <tr key={index}>
                             <td style={{ display: userDetails.storecode?.length > 1 || userDetails?.usertype === "CORP" ? 'table-cell' : 'none' }}>{itemDetail.Location ? itemDetail.Location : ""}</td>
                            <td>{itemDetail.DeviceTransactionNumber ? itemDetail.DeviceTransactionNumber : ""}</td>
                            <td>{itemDetail.RecModified ? formatDate(itemDetail.RecModified) : ""}</td>
                            <td>
                              {itemDetail.TotalAmountWithoutTax
                                ? itemDetail.TotalAmountWithoutTax.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
                                : "$0.00"}
                            </td> 
                            <td>
                              {itemDetail.TotalDiscountAmount
                                ? itemDetail.TotalDiscountAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
                                : "$0.00"}
                            </td> 
                            <td>
                              {itemDetail.TotalTaxAmount
                                ? itemDetail.TotalTaxAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
                                : "$0.00"}
                            </td>   
                            <td>
                              {itemDetail.TotalAmount
                                ? itemDetail.TotalAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
                                : "$0.00"}
                            </td>  
                                                    
            
                          </tr>
                          ))}
                      </tbody>
                    </table> 
                
                  ) : 
                  null}
                </div>
              )}
            </div>


        </div>
      </div>
    </div>
    </>
  )
}
